import { CreateItineraryFromExternalFlightBookingRequestForAdminState } from './createItineraryFromExternalFlightBookingRequestForAdmin.types'

const initialState: CreateItineraryFromExternalFlightBookingRequestForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
